import React from 'react';
import { MetricCard } from '../../atoms/security/MetricCard';
import { Shield, AlertTriangle, AlertCircle, Info } from 'lucide-react';

export interface SecurityMetricsData {
  critical: number | null;
  high: number | null;
  medium: number | null;
  low: number | null;
  info: number | null;
  overall_security_score: number | null;
}

interface SecurityMetricsProps {
  metrics: SecurityMetricsData;
}

export const SecurityMetrics: React.FC<SecurityMetricsProps> = ({ metrics }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-3">
      <MetricCard
        title="Critical"
        value={metrics.critical ?? 0}
        icon={AlertTriangle}
        iconColor="text-red-500"
        valueColor="text-red-500"
      />
      <MetricCard
        title="High"
        value={metrics.high ?? 0}
        icon={AlertCircle}
        iconColor="text-orange-500"
        valueColor="text-orange-500"
      />
      <MetricCard
        title="Medium"
        value={metrics.medium ?? 0}
        icon={AlertCircle}
        iconColor="text-yellow-500"
        valueColor="text-yellow-500"
      />
      <MetricCard
        title="Low"
        value={metrics.low ?? 0}
        icon={Info}
        iconColor="text-blue-500"
        valueColor="text-blue-500"
      />
      <MetricCard
        title="Info"
        value={metrics.info ?? 0}
        icon={Info}
        iconColor="text-muted-foreground"
      />
      <MetricCard
        title="Overall Security Score"
        value={metrics.overall_security_score != null ? metrics.overall_security_score.toFixed(2) : 'N/A'}
        icon={Shield}
        iconColor="text-primary"
        valueColor="text-primary"
      />
    </div>
  );
};
